import { useEffect, useState } from "react";

import { useOrderServiceType } from "./useOrderServiceType";

export const usePalletsSelection = ({ record }) => {
	const { isOutgoingPlukk, isCrossDock } = useOrderServiceType(record);
	const [isLoadingMode, setIsLoadingMode] = useState(false);
	const [isMoveToPreparationMode, setIsMoveToPreparationMode] = useState(false);
	const [selectedPalletsForLoading, setSelectedPalletsForLoading] = useState([]);

	const isSelectionMode = isLoadingMode || isMoveToPreparationMode;

	useEffect(() => {
		if (!isOutgoingPlukk && !isCrossDock && isSelectionMode) {
			setIsLoadingMode(false);
			setIsMoveToPreparationMode(false);
			setSelectedPalletsForLoading([]);
		}
	}, [isOutgoingPlukk, isCrossDock, isSelectionMode]);

	return {
		isLoadingMode,
		setIsLoadingMode,
		isMoveToPreparationMode,
		setIsMoveToPreparationMode,
		selectedPalletsForLoading,
		setSelectedPalletsForLoading,
		isSelectionMode,
	};
};
